module.exports = __webpack_public_path__ + "img/u26.a5e9d210.png";